import React from 'react';

const gothamBlackRegexGlobal = /\|.*?\|/g; // matches |desired gothamBlack text|
const gothamBlackCaptureRegex = /\|(.*?)\|/; // captures |desired gothamBlack text|

const SPLIT_CHAR = '%%&&';

const generateStyledOutput = () => (potentialStyledOutput, index) => {
  const gothamBlackMatchResult = potentialStyledOutput.match(
    gothamBlackCaptureRegex
  ); // yields |desired gothamBlack text|

  if (gothamBlackMatchResult) {
    const copy = gothamBlackMatchResult[1];

    return (
      <span className="gotham-black__content" key={`gothamBlack-${index}`}>
        {copy}
      </span>
    );
  }

  // content is not in styled format!
  return potentialStyledOutput;
};

export default (content) => {
  if (typeof content === 'string') {
    // Wrap all styled output in a split character
    const bookmarkedString = content.replace(
      gothamBlackRegexGlobal,
      (match) => `${SPLIT_CHAR}${match}${SPLIT_CHAR}`
    );
    // Split on split char and map everything you can to styled output
    const result = bookmarkedString
      .split(SPLIT_CHAR)
      .map(generateStyledOutput());
    return result;
  }

  // not parsable
  return content;
};
